import React from "react";
import PropTypes from "prop-types";
import { RefreshCw, ShoppingBasket } from "lucide-react";
import { Button } from "./ui/button";

const resolveStatus = ({ loading, health, error }) => {
  if (loading) {
    return {
      label: "Conectando…",
      tone: "bg-amber-50 text-amber-700 border border-amber-200",
    };
  }

  if (error) {
    return {
      label: "Sin conexión",
      tone: "bg-rose-50 text-rose-700 border border-rose-200",
    };
  }

  if (!health) {
    return {
      label: "Sin datos",
      tone: "bg-neutral-100 text-neutral-600 border border-neutral-200",
    };
  }

  if (health.ok) {
    return {
      label: "Online",
      tone: "bg-emerald-50 text-emerald-700 border border-emerald-200",
    };
  }

  return {
    label: health.status ?? "Degradado",
    tone: "bg-amber-50 text-amber-700 border border-amber-200",
  };
};

const Header = ({ cartItemCount, onCartClick, backendStatus, onRetry }) => {
  const status = resolveStatus(backendStatus ?? {});

  return (
    <header className="sticky top-0 z-30 backdrop-blur supports-[backdrop-filter]:bg-white/70 bg-white/80 border-b">
      <div className="mx-auto max-w-6xl px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3 sm:gap-4">
          <img src="/miyogur-whitefill.svg" alt="miyogur" className="h-6 w-6" />
          <span className="font-semibold">Arma tu yogur</span>
          <span className={`hidden sm:inline-flex items-center gap-2 rounded-soft px-3 py-1 text-xs font-medium ${status.tone}`}>
            <span className="inline-block h-2 w-2 rounded-full bg-current" aria-hidden />
            {status.label}
            {onRetry && (
              <button
                type="button"
                onClick={onRetry}
                className="inline-flex items-center"
                aria-label="Reintentar conexión"
              >
                <RefreshCw className="h-3.5 w-3.5" />
              </button>
            )}
          </span>
        </div>
        <Button variant="pastel" onClick={onCartClick}>
          <ShoppingBasket className="mr-2 h-4 w-4" /> Encargar ({cartItemCount})
        </Button>
      </div>
    </header>
  );
};

Header.propTypes = {
  cartItemCount: PropTypes.number.isRequired,
  onCartClick: PropTypes.func.isRequired,
  backendStatus: PropTypes.shape({
    loading: PropTypes.bool,
    health: PropTypes.object,
    error: PropTypes.instanceOf(Error),
  }),
  onRetry: PropTypes.func,
};

Header.defaultProps = {
  backendStatus: undefined,
  onRetry: undefined,
};

export default React.memo(Header);
